import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@env/environment';
import { MicaChat_ChatsEntity } from '@modules/mica-chat/entities/chats.mica-chat';
import { MicaChat_MensajesEntity } from '@modules/mica-chat/entities/mensajes.mica-chat';
import { BaseHttpService } from '@shared/services/base-http.service';

export interface IEvolutionEstadoConexion {
  estado: 'conectado' | 'desconectado' | 'conectando';
  qr: string | null;
}

export interface IEvolutionEnviarMensajeReq {
  remoteJid: string;
  texto?: string;
  tipo?: string;
  archivoUrl?: string;
  archivoNombre?: string;
  mimeType?: string;
  payload?: Record<string, unknown>;
}

@Injectable({ providedIn: 'root' })
export class EvolutionApiService extends BaseHttpService {
  private readonly base = `${environment.apiMicaChatEvolutionUrl}${environment.apiPreFix}/evolution`;

  cargarChats(telefonoId: number) {
    return this.withLoader(
      this.httpClient.get<MicaChat_ChatsEntity[]>(`${this.base}/chats/cargar/${telefonoId}`),
    );
  }

  cargarMensajes(telefonoId: number, remoteJid: string, page: number = 1, offset: number = 50) {
    const params = `telefonoId=${telefonoId}&remoteJid=${encodeURIComponent(remoteJid)}&page=${page}&offset=${offset}`;
    return this.withLoader(this.httpClient.get<MicaChat_MensajesEntity[]>(`${this.base}/mensajes/cargar?${params}`));
  }

  enviarMensaje(telefonoId: number, dto: IEvolutionEnviarMensajeReq) {
    return this.httpClient.post(`${this.base}/enviar-mensaje/${telefonoId}`, dto);
  }

  obtenerEstadoConexion(telefonoId: number) {
    return this.httpClient.get<IEvolutionEstadoConexion>(`${this.base}/estado-conexion/${telefonoId}`);
  }

  reconectarInstancia(telefonoId: number) {
    return this.httpClient.post<IEvolutionEstadoConexion>(`${this.base}/reconnect/${telefonoId}`, {});
  }

	obtenerMedia(messageId: string, telefonoId: number) {
		return this.httpClient.get<{ base64: string; mimetype: string }>(`${this.base}/media/${messageId}?telefonoId=${telefonoId}`);
	}

	enviarPresencia(telefonoId: number, remoteJid: string, presencia: string) {
		return this.httpClient.post(`${this.base}/enviar-presencia/${telefonoId}`, { remoteJid, presencia });
	}

	marcarChatComoLeido(telefonoId: number, remoteJid: string) {
		return this.httpClient.post(`${this.base}/chats/marcar-leido/${telefonoId}`, { remoteJid });
	}
}
